import {DocUserField, InternalDocummentID, SMMDocumment} from "../document-types";
import {Subject, takeUntil} from "rxjs";
import {DocummentsService} from "../documents.service";
import {ChangeDetectorRef} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {getRawVal, getValueOfFieldWithName} from "./base.behaviour.doc.types";


export abstract class BasicTemplate {
    protected _unsubscribeAll: Subject<any> = new Subject<any>();
    internalDocID:InternalDocummentID;
    documentID:string;
    documentKey:InternalDocummentID;
    docFields: DocUserField[] = [];
    document:SMMDocumment = null;

    constructor(
        private readonly _docsService:DocummentsService,
        private _cdref: ChangeDetectorRef,
        private readonly router: Router,
        private route: ActivatedRoute,
        ) {
    }

    protected init(){
        this._docsService.availableUserDocFields$.pipe(takeUntil(this._unsubscribeAll)).subscribe(value => {
            this.docFields = value;
            this._cdref.markForCheck();
        });

        this.route.queryParams.subscribe(params => {
            this.internalDocID = params['docID'];
            this.documentID = params['doc'];
            this.documentKey = params['key'];

            if (this.documentID == 'BASIC_INFO_DOC') {
                if(this.documentKey){
                    this._docsService.getAllUserInputFieldsObs(this.documentKey).subscribe(value => {
                        this._docsService.updateUserInputFieldsNow(value);
                        this._cdref.markForCheck();
                    })
                }
            }
            else
            {
                this._docsService.getDocFromBE(this.documentID).subscribe(value => {
                    this.document = value;
                    this._docsService.getAllUserInputFieldsObs(this.document.userKey).subscribe(value => {
                        this._docsService.updateUserInputFieldsNow(value);
                        this._cdref.markForCheck();
                    });
                    this._cdref.markForCheck();
                })
            }
        });
    }

    protected destroy(){
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    getSignatureBlobURL(){
        if(this.document?.signature){
            let blob = new Blob([this.document.signature], {type: 'image/svg+xml'});
            return URL.createObjectURL(blob);
        }
        return "";
    }

    getFieldData(key: string) {
        return getValueOfFieldWithName(this.docFields, key, this.documentID);
    }

    getBooleanFieldData(key: string, marker:string, inverted:boolean) {
        const val = getRawVal(this.getFieldData(key));
        if(!inverted){
            if(val === true)
            {
                return marker;
            }
        }
        if(inverted){
            if(val === false || !val)
            {
                return marker;
            }
        }
    }

    getBooleanFieldDataSimple(key: string, markerYes:string, markerNo:string, inverted:boolean) {
        const val = getRawVal(this.getFieldData(key));
        return ((val && !inverted) || (!val && inverted)) ? markerYes : markerNo;
    }

    getSignedDate() {
        if(this.document?.id){
            return this.getFieldData("signature_date_"+this.document?.id);
        }
        return "";
    }

    getSignedHour() {
        if(this.document?.id) {
            return this.getFieldData("signature_hour_" + this.document?.id);
        }
        return "";
    }

}
